import React, { useState, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import "../input/validation.js";
import "../input/DatePicker.js";
import "../input/DateRangePicker.js";
import "../input/StyledInput.js";
import "../input/FormInput.js";
import { withStyledInputLabel } from "../input/StyledFormInputHoc.js";
import "moment-timezone";
import { getObjectListWithUniqueKey, arrayDifference, removeItemsFromArray } from "../../utils/array.js";
import "../input/DateSinglePicker.localize.js";
import "../input/hooks.js";
import "@mui/material";
import { Select } from "./Select.js";
import "../chip/ChipRenderer.js";
import "./selectStyle.js";
import "./MultiSelectFooter.js";
import "./MultiSelect.js";
import "./MultiSelectItem.js";
import "./SelectArrowIcon.js";
import "./VirtualizedMultiSelectOptionList.js";
import "./SingleSelect.js";
import { MultiSelectTextCounterWithTooltip } from "./MultiSelectTextCounterWithTooltip.js";
const localized = defineMessages({
  all: {
    id: "MultiSelectWithExclude_all",
    defaultMessage: "All"
  },
  allExcept: {
    id: "MultiSelectWithExclude_allExcept",
    defaultMessage: "All except {except}"
  },
  allButSome: {
    id: "MultiSelectWithExclude_allButSome",
    defaultMessage: "All but some"
  },
  tooltipTitleAll: {
    id: "MultiSelectWithExclude_tooltipTitleAll",
    defaultMessage: "All {itemsName} selected"
  },
  tooltipTitleAllExcept: {
    id: "MultiSelectWithExclude_tooltipTitleAllExcept",
    defaultMessage: "Selected all {itemsName} except"
  },
  tooltipTitleSelected: {
    id: "MultiSelectWithExclude_tooltipTitleSelected",
    defaultMessage: "Selected {itemsName}"
  }
});
class MultiSelectWithExcludeModel {
  include;
  exclude;
}
function MultiSelectWithExclude({
  value,
  options,
  valueOptions,
  total,
  onValueChange,
  itemsName,
  inputLabel,
  inputChipColor,
  initialMode = "exclude",
  ...props
}) {
  const [selectAll, setSelectAll] = useState(initialMode === "exclude");
  const [allOptions, setAllOptions] = useState([]);
  const { formatMessage } = useIntl();
  useEffect(() => {
    setSelectAll(initialMode === "exclude");
  }, [initialMode]);
  useEffect(() => {
    if (options) {
      setAllOptions((prevState) => getObjectListWithUniqueKey([...prevState, ...options], "value"));
    }
  }, [options?.map((o) => `${o.label}${o.value}`).join()]);
  function handleValueChange(newValues) {
    if (newValues) {
      const newModel = value ? { ...value } : { include: [], exclude: [] };
      if (selectAll) {
        const selectedValues = getSelectedValues();
        if (selectedValues?.length > newValues?.length) {
          newModel.exclude.push(...arrayDifference(selectedValues, newValues));
        } else {
          newModel.exclude = removeItemsFromArray(newModel.exclude, arrayDifference(newValues, selectedValues)[0]);
        }
      } else {
        newModel.include = newValues;
      }
      onValueChange(newModel);
    } else {
      onValueChange({ include: [], exclude: [] });
      setSelectAll(false);
    }
  }
  function handleSelectAll(v) {
    onValueChange({ include: [], exclude: [] });
    setSelectAll(v);
  }
  function getValueData() {
    const result = {
      tooltipTitle: formatMessage(localized.tooltipTitleAll, { itemsName }),
      selectedTotal: total,
      values: null,
      label: formatMessage(localized.all)
    };
    const options2 = valueOptions ?? allOptions;
    if (value?.include?.length) {
      result.selectedTotal = value?.include?.length;
      result.tooltipTitle = formatMessage(localized.tooltipTitleSelected, { itemsName });
      result.values = value.include?.map((v) => options2?.find((o) => o.value === v)?.label ?? v);
      result.label = null;
    } else if (value?.exclude?.length) {
      result.selectedTotal = value?.exclude?.length;
      result.tooltipTitle = formatMessage(localized.tooltipTitleAllExcept, { itemsName });
      result.values = value.exclude?.map((v) => options2?.find((o) => o.value === v)?.label ?? v);
      result.label = value.exclude.length === 1 ? formatMessage(localized.allExcept, { except: result.values[0] }) : formatMessage(localized.allButSome);
    }
    return result;
  }
  function getSelectedValues() {
    return allOptions?.map((o) => typeof o.value === "boolean" ? o.value ? "true" : "false" : o.value.toString()).filter((v) => selectAll ? !value.exclude.includes(v) : value.include.includes(v));
  }
  const { selectedTotal, tooltipTitle, values, label } = getValueData();
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      multiple: true,
      value: getSelectedValues(),
      defaultSelectAll: selectAll,
      hasSelectAll: true,
      options,
      onSelectAll: handleSelectAll,
      onSubmit: handleValueChange,
      renderValue: () => /* @__PURE__ */ React.createElement(
        MultiSelectTextCounterWithTooltip,
        {
          label,
          filterLabel: inputLabel,
          color: inputChipColor,
          tooltipTitle,
          selectedTotal,
          values
        }
      ),
      total: props.hasSearch ? props.filteredTotal : total,
      ...props
    }
  );
}
const MultiSelectWithExcludeFormInput = withStyledInputLabel(MultiSelectWithExclude);
export {
  MultiSelectWithExclude,
  MultiSelectWithExcludeFormInput,
  MultiSelectWithExcludeModel
};
//# sourceMappingURL=MultiSelectWithExclude.js.map
